"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointInBoundaryNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const helpers_1 = require("../../../utils/helpers");
const helpers_2 = require("@turf/helpers");
const boolean_point_in_polygon_1 = __importDefault(require("@turf/boolean-point-in-polygon"));
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'POINT-IN-BOUNDARY';
class PointInBoundaryNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            try {
                const existingLine = helpers_1.getLineFromString(params.boundary);
                const turfPoly = helpers_2.polygon([existingLine.coordinates]);
                return { output: boolean_point_in_polygon_1.default(helpers_2.point([params.longitude, params.latitude]), turfPoly) };
            }
            catch (e) { }
            return { output: false };
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
}
exports.PointInBoundaryNode = PointInBoundaryNode;
PointInBoundaryNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Point In Boundary',
    isIdempotent: true,
    primaryCategory: 'Geography',
};
//# sourceMappingURL=PointInBoundary.js.map